import { BrandMark } from "@/components/brand-mark";
import { ThemeToggle } from "@/components/theme-toggle";
import { cn } from "@/lib/utils";
import type { ShareBrand } from "@/hooks/use-share";

/** True when the workspace has set a custom logo or name. */
export function hasCustomBrand(brand?: ShareBrand | null): boolean {
  return !!(brand && (brand.logoUrl || brand.name));
}

/**
 * Guest-page header (BR-3). Shows the workspace logo + name when branding is
 * set, otherwise falls back to the default Editlock BrandMark.
 */
export function ShareBrandHeader({ brand }: { brand?: ShareBrand | null }) {
  return (
    <header className="flex items-center justify-between border-b border-border px-4 py-3 md:px-8 md:py-4">
      {hasCustomBrand(brand) ? (
        <div className="inline-flex items-center gap-2.5">
          {brand?.logoUrl ? (
            <img src={brand.logoUrl} alt="" aria-hidden className="h-7 w-7 rounded object-contain" />
          ) : null}
          <span className="font-display text-lg font-bold tracking-tight">{brand?.name || "Editlock"}</span>
        </div>
      ) : (
        <BrandMark />
      )}
      <ThemeToggle />
    </header>
  );
}

/** Small attribution footer shown on branded (white-labeled) guest pages. */
export function PoweredByEditlock({ className }: { className?: string }) {
  return (
    <div className={cn("py-8 text-center text-xs text-muted-foreground", className)}>
      Powered by <span className="font-medium text-foreground/70">Editlock</span>
    </div>
  );
}
